
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/refund-policy",
      function () {
        return require("private-next-pages/[lng]/refund-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/refund-policy"])
      });
    }
  